var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 9.282,
    cy: 6.761,
    r: 0.612,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.714,3.119h-3.9V8.993a3.9,3.9,0,0,0,3.9,3.9h0a3.9,3.9,0,0,0,3.9-3.9V3.119Zm-2.2,3.642a.612.612,0,1,1,.612.611A.612.612,0,0,1,5.517,6.761ZM7.7,10.727A1.727,1.727,0,0,1,5.986,9V8.81H7.7Zm2.882-1.734a2.872,2.872,0,0,1-2.868,2.868h0V10.728H9.441v-.19A1.728,1.728,0,0,0,7.714,8.81V4.151h2.868Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeater);
export default __webpack_public_path__ + "static/media/TEATER.2fe78f237d85bf32d4909280147b8e27.svg";
export { ForwardRef as ReactComponent };